const btn = document.getElementById("backToTop");

window.addEventListener("scroll", function () {
  if (window.scrollY > 400) {
    btn.style.display = "block";
  } else {
    btn.style.display = "none";
  }
});

btn.addEventListener("click", function () {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[data-target="goto-newsletter"]').forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      //const targetId = this.getAttribute("data-target");
      const targetEl = document.querySelector(".email-signup-block");

      if (targetEl) {
        targetEl.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});
